import { render } from "./ArchiveOrders.vue?vue&type=template&id=7fccbd17"
import script from "./ArchiveOrders.vue?vue&type=script&lang=js"
export * from "./ArchiveOrders.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/orders/ArchiveOrders.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7fccbd17"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7fccbd17', __exports__)) {
    console.log('reload')
    api.reload('7fccbd17', __exports__)
  }
  
  module.hot.accept("./ArchiveOrders.vue?vue&type=template&id=7fccbd17", () => {
    console.log('re-render')
    api.rerender('7fccbd17', render)
  })

}


export default __exports__